import { useAppDispatch } from 'src/app/store/hooks';
import Modal from 'src/components/ui/Modal';
import Button from 'src/components/ui/Button';
import { setGlobalError } from '../features/notifications/redux';

// Props: error (NormalizedError), actions (array of { label, onClick, variant })
function ApiErrorDialog({ error, actions = [], onClose: externalOnClose }) {
  const dispatch = useAppDispatch();

  // Default close handler
  const handleClose = () => {
    dispatch(setGlobalError({ error: null, actions: undefined }));
    if (externalOnClose) externalOnClose();
  };

  // Default Contact Support action
  const sendSupportEmail = () => {
    if (!error) return;
    const errorCode = error.code;
    const errorTitle = error.title || '';
    const errorDescription = error.description || '';
    const supportEmail = 'support@complimind.co.uk';
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    const userName = user.firstname || 'Unknown User';
    const userEmail = user.email || 'No email provided';
    const subject = encodeURIComponent(`Support Request: ${errorTitle} (Error Code: ${errorCode})`);
    const body = encodeURIComponent(
      `Dear CompliMind Team,\n\nI encountered an issue while using the application. Here are the details:\n\nError Code: ${errorCode}\nError Title: ${errorTitle}\nDescription: ${errorDescription}\nContext: ${error.context || 'unknown'}\nTimestamp: ${new Date(error.timestamp || Date.now()).toISOString()}\nRequest ID: ${error.requestId || 'N/A'}\n\nUser Details:\nName: ${userName}\nEmail: ${userEmail}\n\nPlease assist me in resolving this issue.\n\nBest regards,\n${userName}\n`
    );
    handleClose();
    window.open(`mailto:${supportEmail}?subject=${subject}&body=${body}`);
  };

  // Default actions if none provided
  const defaultActions = [
    {
      label: 'Contact Support',
      onClick: sendSupportEmail,
      variant: 'primary'
    },
    {
      label: error?.recoverable ? 'OK' : 'Close',
      onClick: handleClose,
      variant: 'secondary'
    }
  ];

  if (!error?.code) return null;

  return (
    <Modal
      open={!!error}
      onClose={handleClose}
      title={<h2 className="text-base font-medium text-content-default">{error.title || 'Error'}</h2>}
      className="max-w-md mx-4 p-6"
    >
      <div className="space-y-4">
        <p className="text-content-default">{error.description || ''}</p>
        {error.requestId && <p className="text-sm text-gray-500">Request ID: {error.requestId}</p>}
        <div className="flex justify-end gap-2">
          {(actions.length > 0 ? actions : defaultActions).map((action, idx) => (
            <Button key={idx} variant={action.variant || 'primary'} onClick={action.onClick}>
              {action.label}
            </Button>
          ))}
        </div>
      </div>
    </Modal>
  );
}

export default ApiErrorDialog;
